import { useState } from "react";
import { postRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const useToSaveKeyFobs = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setLoading] = useState(false);

  const saveKeyFobsData = async (payload) => {
    try {
      setData();
      setError("");
      setLoading(true);
      const _response = await postRequest(urls.SAVE_VINS, payload);
      setData(_response?.data ?? []);
    } catch (error) {
      setError(error?.response?.data?.message || "Unable to update the data");
      setData(error?.response?.data ?? []);
    } finally {
      setLoading(false);
    }
  };

  return {
    data,
    error,
    isLoading,
    saveKeyFobsData,
  };
};
